import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './auth/AuthProvider';
import { RequireAuth } from './auth/RequireAuth';
import { Layout } from './layout/Layout';
import { MeihuaPage } from './pages/MeihuaPage';
import { HistoryPage } from './pages/HistoryPage';
import { SettingsPage } from './pages/SettingsPage';
import { SignInPage } from './pages/SignInPage';
import { QimenPage } from './pages/QimenPage';
import { BaziPage } from './pages/BaziPage';
import { PricingPage } from './pages/PricingPage';

const App: React.FC = () => {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/auth" element={<SignInPage />} />
        <Route
          path="/app"
          element={
            <RequireAuth>
              <Layout />
            </RequireAuth>
          }
        >
          <Route index element={<Navigate to="meihua" replace />} />
          <Route path="meihua" element={<MeihuaPage />} />
          <Route path="qimen" element={<QimenPage />} />
          <Route path="bazi" element={<BaziPage />} />
          <Route path="history" element={<HistoryPage />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route path="pricing" element={<PricingPage />} />
          {/* 旧地址兼容：起局与解卦已合并为「梅花」 */}
          <Route path="ai" element={<Navigate to="/app/meihua" replace />} />
          <Route path="gua" element={<Navigate to="/app/meihua" replace />} />
        </Route>
        <Route
          path="/"
          element={
            <RequireAuth>
              <Navigate to="/app/meihua" replace />
            </RequireAuth>
          }
        />
        <Route path="*" element={<Navigate to="/app/meihua" replace />} />
      </Routes>
    </AuthProvider>
  );
};

export default App;
